<template>
  <div class="ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3 mr-4">
      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="heading" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>

    <div v-show="!showSkeleton">
      <div class="text-h4">Configuração</div>

      <v-form ref="form" class="mt-4">
        <!-- /INICIO MONITOR DE OPERADORES -->

        <v-card class=" my-6 px-6" elevation="1" outlined>

          <v-row class="mt-4 mb-8 pl-2" align="center">
            <v-icon large>mdi-card-account-phone-outline</v-icon>
            <h2 class="text-h5 d-inline pl-2">Monitor de operadores</h2>
          </v-row>

          <v-row>
            <v-col>
              <v-select outlined dense label="Tempo" v-model="form.time" :items="time" />
            </v-col>
            <v-col>
              <v-select outlined dense v-model="form.type" label="Tipos de ligações de entrada" :items="tipos"
                :error-messages="typeErrors"></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field outlined dense type="text" v-mask="['##:##:##', '##:##', '##']"
                label="Tempo mínimo para chamada" v-model="form.timeMin" :error-messages="timeMinErrors"
                @input="$v.form.timeMin.$touch()" @blur="$v.form.timeMin.$touch()" />
            </v-col>
            <v-col>
              <v-autocomplete v-model="form.tags" :items="tags" outlined multiple dense :label="'Tags'">
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.text }}</span>
                  <v-chip v-if="index === 1" small>
                    <span class="caption">
                      (+{{ form.tags.length - 1 }})
                    </span>
                  </v-chip>
                </template>
                <template v-slot:prepend-item>
                  <v-list-item ripple @click="toggle">
                    <v-list-item-action>
                      <v-icon :color="form.tags.length > 0 ? 'indigo darken-4' : ''">
                        {{ icon }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        Selecionar Todos
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2" />
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card>
        <!-- /FIM MONITOR DE OPERADORES -->
        <v-card class=" my-6 px-6" elevation="1" outlined>

          <v-row class="mt-4 mb-8 pl-2" align="center">
            <v-icon large>mdi-card-account-phone-outline</v-icon>
            <h2 class="text-h5 d-inline pl-2">Configuração de fila</h2>
          </v-row>
          <p class="text-h9 d-inline pl-2">Configuração de Autopause</p>

          <v-row class="ml-1">
            <!-- <v-col cols="6"> -->
            <v-checkbox v-model="form.autopauseOptions" label="Fora do gancho" value="Down"></v-checkbox>
            <v-checkbox v-model="form.autopauseOptions" label="Não atendida" value="Ringing" class="ml-3"></v-checkbox>
            <!-- </v-col> -->

          </v-row>
        </v-card>

        <v-card class=" my-6 px-6" elevation="1" outlined>

          <v-row class="mt-4 mb-8 pl-2" align="center">
            <v-icon large>mdi-whatsapp</v-icon>
            <h2 class="text-h5 d-inline pl-2">Configuração WhatsApp</h2>
          </v-row>

          <v-row>
            <v-col>
              <v-text-field outlined dense label="Token" v-model="formWhats.token" :error-messages="tokenWhatsErrors"
                @input="$v.formWhats.token.$touch()" @blur="$v.formWhats.token.$touch()" />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field outlined dense label="URL" v-model="formWhats.url" :error-messages="urlWhatsErrors"
                @input="$v.formWhats.url.$touch()" @blur="$v.formWhats.url.$touch()"
                placeholder="https://w3.pcmsolucoes.com.br" />
            </v-col>
            <v-col cols="4">
              <v-text-field outlined dense label="Code" v-model="formWhats.code" :error-messages="codeWhatsErrors"
                @input="$v.formWhats.code.$touch()" @blur="$v.formWhats.code.$touch()" placeholder="56" />
            </v-col>
          </v-row>
        </v-card>

        <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader"
          :disableSaveButton="permissaoVisualizar" />
      </v-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import FixedButtons from '@/componentes/FixedButtons'
import Snackbar from '@/componentes/Snackbar'
import { mask } from 'vue-the-mask'

import configStore from '../_store'
import { validateData, validateComputed } from '../_validates'
import configCallCenterHttpService from '../_services/configCallCenterHttpService'
import whatsappConfigHttpService from '../_services/whatsappConfigHttpService'
import { Mixins } from '../_mixin/Mixins'

export default {
  directives: { mask },
  components: { Snackbar, FixedButtons },
  mixins: [Mixins],

  data: () => ({
    text: '',
    snackbar: false,
    form: {
      time: '',
      type: [],
      timeMin: 0,
      tags: [],
      autopauseOptions: [],
    },
    formWhats: {
      token: '',
      url: '',
      code: '',
    },
    showSkeleton: true,
    permissaoVisualizar: false,
    pararLoader: {
      parar: false,
    },
    tags: [],
    timeMin: 0,

  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...validateComputed,
    ...mapGetters('configCallCenterStore', ['getConfig', 'getTags']),
  },

  async created() {
    this.showSkeleton = true
    registerVuexModule(this.$store, 'configCallCenterStore', configStore)
    await this.listarconfig()
    await this.listartags()
    await this.fetchWhatsappConfig()

    this.tags = this.getTags.map(tags => ({
      text: `${tags.description}`,
      value: `${tags._id}`
    }))
    if (this.getConfig.autopauseOptions == undefined) {
      this.form = { ...this.getConfig, autopauseOptions: [] }
    } else {
      this.form = { ...this.getConfig }
    }
    this.form.timeMin = new Date(this.getConfig.timeMin * 1000).toISOString().substr(11, 8)

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('configCallCenterStore', ['listarconfig', 'listartags']),

    async fetchWhatsappConfig() {
      try {
        const response = await whatsappConfigHttpService.getConfig()
        if (response.data) {
          this.formWhats.token = response.data.token || ''
          this.formWhats.url = response.data.url || ''
          this.formWhats.code = response.data.code || ''
        }
      } catch (error) {
        console.error('Error fetching WhatsApp configuration:', error)
        this.text = 'Erro ao carregar configuração do WhatsApp'
        this.snackbar = true
      }
    },

    cancelar() {
      this.$router.push({ name: 'callcenter' })
    },

    async salvar() {
      this.pararLoader.parar = false

      this.$v.form.$touch()
      if (this.$v.form.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }

      // Validar configuração do WhatsApp (token e code são obrigatórios, url é opcional)
      this.$v.formWhats.$touch()
      if (this.$v.formWhats.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }

      try {
        this.showSkeleton = true
        this.form.timeMin = this.converterTempo(this.form.timeMin)
        await configCallCenterHttpService.putConfig(this.form)

        await whatsappConfigHttpService.postConfig(this.formWhats)

        this.$router.push({ name: 'callcenter' })
      } catch (error) {
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
  },
}
</script>
